import React from 'react';

export default function CookiesPolicyPage() {
  return (
    <div className="min-h-screen py-12 px-4" style={{ backgroundColor: '#FDFBF7' }}>
      <div className="max-w-4xl mx-auto">
        <article className="prose prose-lg max-w-none">
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-primary mb-8" style={{ color: '#2C3E50' }}>
            Política de Cookies
          </h1>

          {/* Section 1 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              1. Qué son las cookies
            </h2>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              Las cookies son pequeños archivos que pueden almacenarse en el dispositivo del usuario al visitar una página web.
            </p>
          </section>

          {/* Section 2 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              2. Uso de cookies en este sitio
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              El sitio web <strong>tantra-map.com</strong> actualmente <strong>no utiliza cookies propias ni cookies de terceros con fines de análisis, seguimiento o publicidad</strong>.
            </p>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              La navegación por el sitio puede implicar únicamente tecnologías técnicas necesarias para el funcionamiento de la plataforma.
            </p>
          </section>

          {/* Section 3 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              3. Servicios externos
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              El sitio utiliza servicios externos que pueden aplicar sus propias políticas:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2 mb-4" style={{ color: '#5D6D7E' }}>
              <li>OpenStreetMap</li>
              <li>Resend</li>
              <li>Emergent</li>
            </ul>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              Se recomienda consultar las políticas de privacidad de dichos servicios.
            </p>
          </section>

          {/* Section 4 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              4. Cambios en la política
            </h2>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              La presente política podrá modificarse si cambian las tecnologías utilizadas o la normativa aplicable.
            </p>
          </section>

        </article>
      </div>
    </div>
  );
}
